import React from 'react';
import { EsenciaAurica } from './pages/EsenciaAurica';
export function App() {
  return <div className="min-h-screen" data-id="element-0">
      <EsenciaAurica data-id="element-1" />
    </div>;
}